/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyBaseData } from './companyBaseData';
import { ClientsConfiguration } from './clientsConfiguration';


export interface WorkflowAccess { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    workflowId: string;
    allClients?: boolean;
    agency: CompanyBaseData;
    clients?: Array<ClientsConfiguration>;
}

